import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import makeRequest from "services/makeRequest";
import { routes } from "routes/apiRoutes";
import { ROUTES } from "routes/routePaths";
import { Loader, Typography } from "components";
import { setGuarantorsDetail } from "redux/actions/onboardingActions";

import {
  isSuccessResponse,
  notFoundStatus,
  getIdentificationType,
  capitalizeFirstLetter,
  getGender,
} from "utils/helper";
import { useNavigate } from "react-router-dom";
//
const GuarantorInfo = ({ agentId }) => {
  const [loading, setLoading] = useState(false);

  const { guarantorsDetail } = useSelector((state) => state.onBoardingInfo);

  const { user } = useSelector((state) => state.user);

  const navigate = useNavigate();

  useEffect(() => {
    const getAgentGuarantorDetails = async () => {
      setLoading(true);
      try {
        const { data } = await makeRequest(
          "get",
          routes.guarantorInfo(agentId)
        );

        if (isSuccessResponse(data)) {
          const guarantorsDetail = [...data.data];
          setGuarantorsDetail(guarantorsDetail);
        }
        setLoading(false);
      } catch (error) {
        if (notFoundStatus(error)) {
          setLoading(false);
        }
      }
    };
    !guarantorsDetail && getAgentGuarantorDetails();
  }, [agentId, guarantorsDetail]);

  if (loading)
    return (
      <div className="d-flex justify-content-center onboarding-loader">
        <Loader />
      </div>
    );

  if ((!guarantorsDetail || !guarantorsDetail.length) && !loading) {
    return user?.agent_id === agentId ? (
      <>
        <Typography variant="subtitle3" className={"text-center mt-3"}>
          You are yet to provide your guarantor information
        </Typography>
        <Typography
          variant="body2"
          className={"mt-4 text-underline cursor-pointer text-center"}
          state="primary"
          onClick={() => navigate(ROUTES.userGuarantorInfo)}
        >
          Click here to submit now
        </Typography>
      </>
    ) : (
      <Typography variant="subtitle3" className={"text-center mt-3"}>
        This agent has not provided guarantor's information yet
      </Typography>
    );
  }

  return (
    <div className="row user-detail-container">
      {guarantorsDetail?.map(
        ({
          firstName,
          lastName,
          phoneNumber,
          gender,
          email,
          address,
          region,
          state,
          identificationType,
          identificationNumber,
        }) => {
          const renderDetails = [
            { label: "First Name", value: capitalizeFirstLetter(firstName) },
            { label: "Last Name", value: capitalizeFirstLetter(lastName) },
            { label: "Gender", value: getGender(gender)?.label },
            { label: "Phone Number", value: phoneNumber },
            { label: "Email", value: email },
            { label: "Address", value: address },
            { label: "State", value: state },
            { label: "Region", value: region },
            {
              label: "Identification Type",
              value: getIdentificationType(identificationType)?.label,
            },
            { label: "Identification Number", value: identificationNumber },
          ];
          return renderDetails.map(({ label, value }, key) => (
            <div className="col-md-6 mt-3" key={key}>
              <Typography>
                {label}: &nbsp; &nbsp; {value}
              </Typography>
            </div>
          ));
        }
      )}
    </div>
  );
};

export default GuarantorInfo;
